(() => {
  const init = () => {
    document.documentElement.classList.remove('no-js');

    // Header behavior
    const header = document.querySelector('[data-hachi-header]');
    if (header) {
      let lastY = window.scrollY;
      const onScroll = () => {
        if (document.body.classList.contains('header-nav-open')) return;
        const y = window.scrollY;
        const goingDown = y > lastY;
        lastY = y;
        header.toggleAttribute('data-scrolled', y > 4);
        header.toggleAttribute('data-hidden', goingDown && y > 120);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      const navToggle = header.querySelector('[data-header-nav-toggle]');
      const navDrawer = document.querySelector('[data-header-nav-drawer]');
      const navBackdrop = document.querySelector('[data-header-nav-backdrop]');
      const navClose = document.querySelector('[data-header-nav-close]');

      const setNavOpen = (open) => {
        header.classList.toggle('is-header-nav-open', open);
        document.body.classList.toggle('header-nav-open', open);
        if (navToggle) navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (navToggle) navToggle.setAttribute('aria-label', open ? '關閉選單' : '開啟選單');
        if (navDrawer) navDrawer.hidden = !open;
        if (navBackdrop) navBackdrop.hidden = !open;
      };

      const openNav = () => setNavOpen(true);
      const closeNav = () => setNavOpen(false);

      if (navToggle && navDrawer) {
        navToggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (header.classList.contains('is-header-nav-open')) closeNav();
          else openNav();
        });
      }
      navClose?.addEventListener('click', closeNav);
      navBackdrop?.addEventListener('click', closeNav);

      navDrawer?.querySelectorAll('a.hachi-menu__link').forEach((link) => {
        link.addEventListener('click', closeNav);
      });

      navDrawer?.querySelectorAll('.hachi-menu__details').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          const list = details.closest('.hachi-menu--mobile, .hachi-menu__sub');
          if (!list) return;
          list.querySelectorAll(':scope > .hachi-menu__item > .hachi-menu__details').forEach((other) => {
            if (other !== details) other.open = false;
          });
        });
      });

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && header.classList.contains('is-header-nav-open')) closeNav();
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth >= 1024 && header.classList.contains('is-header-nav-open')) closeNav();
      });
    }

    // Product gallery (thumbnail switching)
    const galleries = document.querySelectorAll('[data-product-gallery]');
    galleries.forEach((gallery) => {
      const mainImg = gallery.querySelector('[data-product-gallery-main]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-product-gallery-thumb]'));
      if (!mainImg || thumbs.length === 0) return;

      const setActive = (btn) => {
        thumbs.forEach((t) => t.setAttribute('aria-current', t === btn ? 'true' : 'false'));
      };

      gallery.addEventListener('click', (e) => {
        const btn = e.target instanceof Element ? e.target.closest('[data-product-gallery-thumb]') : null;
        if (!btn) return;
        e.preventDefault();

        const fullSrc = btn.getAttribute('data-full-src');
        const alt = btn.getAttribute('data-alt') || '';
        if (!fullSrc) return;

        if (mainImg.getAttribute('src') !== fullSrc) {
          mainImg.setAttribute('src', fullSrc);
        }
        mainImg.setAttribute('alt', alt);
        setActive(btn);
      });
    });

    // Back link: prefer history back when available
    document.querySelectorAll('[data-back-link]').forEach((link) => {
      link.addEventListener('click', (e) => {
        if (window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      });
    });

    // Product form: show stock + clamp quantity to stock
    document.querySelectorAll('[data-product-form]').forEach((form) => {
      const variantSelect = form.querySelector('select[name="id"]');
      const qtyInput = form.querySelector('[data-qty-input]');
      const stockText = form.querySelector('[data-stock-text]');
      const addBtn = form.querySelector('[data-add-to-cart]');
      const buyArea = form.querySelector('[data-buy-area]');
      const soldOutLabel = form.querySelector('[data-soldout-label]');
      const soldOutOverlay = form.closest('.product-page, .single-product-page')?.querySelector('[data-soldout-overlay]');
      const checkoutBtn = form.querySelector('[data-checkout-btn]');

      if (!qtyInput || !stockText) return;

      const applyStock = (stock) => {
        if (typeof stock === 'number' && Number.isFinite(stock)) {
          stockText.textContent = String(stock);
          if (stock > 0) {
            qtyInput.setAttribute('max', String(stock));
            if (Number(qtyInput.value) > stock) qtyInput.value = String(stock);
          } else {
            qtyInput.setAttribute('max', '0');
            qtyInput.value = '0';
          }
        } else {
          stockText.textContent = '—';
          qtyInput.removeAttribute('max');
          if (!qtyInput.value || Number(qtyInput.value) < 1) qtyInput.value = '1';
        }
      };

      const clampQty = () => {
        const min = Number(qtyInput.getAttribute('min') || 1);
        const maxAttr = qtyInput.getAttribute('max');
        const max = maxAttr != null && maxAttr !== '' ? Number(maxAttr) : null;
        let v = Number(qtyInput.value);
        if (!Number.isFinite(v)) v = min;
        if (v < min) v = min;
        if (max != null && Number.isFinite(max) && v > max) v = max;
        qtyInput.value = String(v);
      };

      const updateFromVariant = () => {
        const selectedOption =
          variantSelect && typeof variantSelect.selectedIndex === 'number'
            ? variantSelect.options[variantSelect.selectedIndex]
            : null;

        const stockAttr = selectedOption
          ? selectedOption.getAttribute('data-stock')
          : form.getAttribute('data-initial-stock');
        const stock = stockAttr != null && stockAttr !== '' ? Number(stockAttr) : null;

        const initialAvailableAttr = form.getAttribute('data-initial-available');
        const isAvailable = selectedOption
          ? !selectedOption.disabled
          : initialAvailableAttr === 'true';

        applyStock(stock);
        clampQty();

        const qty = Number(qtyInput.value);
        const out =
          !isAvailable ||
          qty <= 0 ||
          (typeof stock === 'number' && Number.isFinite(stock) && stock <= 0);

        if (buyArea && soldOutLabel) {
          // Hide qty + button when sold out, show fixed label instead
          const buyRow = buyArea.querySelector('.product-page__buyrow');
          if (buyRow) buyRow.style.display = out ? 'none' : '';
          soldOutLabel.style.display = out ? '' : 'none';
        }

        if (soldOutOverlay) {
          soldOutOverlay.hidden = !out;
          soldOutOverlay.setAttribute('aria-hidden', out ? 'false' : 'true');
        }

        if (checkoutBtn) checkoutBtn.disabled = out;

        if (addBtn) {
          addBtn.disabled = out;
          addBtn.textContent = '加入購物車';
        }
      };

      if (variantSelect) {
        variantSelect.addEventListener('change', updateFromVariant);
      }
      qtyInput.addEventListener('input', () => {
        clampQty();
        if (addBtn) {
          const maxAttr = qtyInput.getAttribute('max');
          const max = maxAttr != null && maxAttr !== '' ? Number(maxAttr) : null;
          const qty = Number(qtyInput.value);
          if (max != null && Number.isFinite(max) && qty > max) qtyInput.value = String(max);
        }
      });

      updateFromVariant();

      form.addEventListener('submit', async (e) => {
        if (e.submitter?.hasAttribute('data-checkout-btn')) return;

        e.preventDefault();
        const checkoutBtn = form.querySelector('[data-checkout-btn]');
        const label = addBtn ? addBtn.textContent : '加入購物車';

        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = '加入中…';
        }
        if (checkoutBtn) checkoutBtn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          const data = await res.json();
          if (!res.ok) {
            throw new Error(data.description || data.message || '加入購物車失敗');
          }

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

          if (addBtn) {
            addBtn.textContent = '已加入 ✓';
            window.setTimeout(() => {
              addBtn.textContent = label;
              addBtn.disabled = false;
            }, 1600);
          }
        } catch (err) {
          const msg = err instanceof Error ? err.message : '加入購物車失敗';
          window.alert(msg);
          if (addBtn) {
            addBtn.textContent = label;
            addBtn.disabled = false;
          }
        } finally {
          if (checkoutBtn) checkoutBtn.disabled = false;
        }
      });
    });

    // Hero carousel — height from active slide image; contain = full image visible (esp. mobile)
    const updateHeroCarouselHeight = (root) => {
      const viewport = root.querySelector('[data-hero-viewport]');
      if (!viewport) return;

      const slide =
        root.querySelector('[data-hero-slide].is-active') || root.querySelector('[data-hero-slide]');
      if (!slide) return;

      const img = slide.querySelector('.hero-carousel__img');
      const boxW = Math.max(1, viewport.getBoundingClientRect().width || root.offsetWidth || 1);
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const isMobile = vw <= 639;
      const maxH = isMobile ? vh * 0.88 : Math.min(vh * 0.78, 720);

      let iw = 0;
      let ih = 0;
      if (img) {
        if (img.naturalWidth > 0 && img.naturalHeight > 0) {
          iw = img.naturalWidth;
          ih = img.naturalHeight;
        } else {
          iw = Number(img.getAttribute('width')) || 0;
          ih = Number(img.getAttribute('height')) || 0;
        }
      }

      let hPx;
      if (iw > 0 && ih > 0) {
        const idealH = (boxW * ih) / iw;
        hPx = Math.min(idealH, maxH);
      } else {
        hPx = Math.min(boxW * 0.52, maxH, isMobile ? vh * 0.45 : 420);
      }

      hPx = Math.max(180, Math.round(hPx));
      viewport.style.height = `${hPx}px`;
    };

    let heroResizeTimer = null;
    const scheduleHeroResize = () => {
      window.clearTimeout(heroResizeTimer);
      heroResizeTimer = window.setTimeout(() => {
        document.querySelectorAll('[data-hero-carousel]').forEach(updateHeroCarouselHeight);
      }, 80);
    };

    document.querySelectorAll('[data-hero-carousel]').forEach((root) => {
      updateHeroCarouselHeight(root);
      root.querySelectorAll('.hero-carousel__img').forEach((im) => {
        if (im.complete) return;
        im.addEventListener('load', () => updateHeroCarouselHeight(root), { once: true });
      });

      const viewportEl = root.querySelector('[data-hero-viewport]');
      if (viewportEl && typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(() => updateHeroCarouselHeight(root));
        ro.observe(viewportEl);
      }

      requestAnimationFrame(() => updateHeroCarouselHeight(root));

      const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      if (slides.length <= 1) return;

      const anim = root.getAttribute('data-hero-animation') || 'fade';
      const track = root.querySelector('[data-hero-track]');
      const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      const prev = root.querySelector('[data-hero-prev]');
      const next = root.querySelector('[data-hero-next]');
      const autoplayMs = Number(root.getAttribute('data-autoplay-ms') || '0');

      let index = slides.findIndex((s) => s.classList.contains('is-active'));
      if (index < 0) index = 0;
      let timer = null;

      const applySlideTransform = () => {
        if (anim !== 'slide' || !track) return;
        track.style.transform = `translateX(calc(-${index} * 100% / ${slides.length}))`;
      };

      const go = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
        dots.forEach((d, i) => {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        applySlideTransform();
        updateHeroCarouselHeight(root);
      };

      const restart = () => {
        if (timer) window.clearInterval(timer);
        if (autoplayMs > 0) {
          timer = window.setInterval(() => go(index + 1), autoplayMs);
        }
      };

      applySlideTransform();
      prev?.addEventListener('click', () => {
        go(index - 1);
        restart();
      });
      next?.addEventListener('click', () => {
        go(index + 1);
        restart();
      });
      dots.forEach((d) => {
        d.addEventListener('click', () => {
          const idx = Number(d.getAttribute('data-hero-dot'));
          if (Number.isFinite(idx)) go(idx);
          restart();
        });
      });

      // Mobile / touch: swipe on viewport (arrows hidden below 640px in CSS)
      const swipeTarget = viewportEl || root;
      let touchStartX = null;
      let touchStartY = null;
      const SWIPE_THRESHOLD_PX = 48;
      swipeTarget.addEventListener(
        'touchstart',
        (e) => {
          if (!window.matchMedia('(max-width: 639px)').matches) return;
          const t = e.changedTouches[0];
          touchStartX = t.screenX;
          touchStartY = t.screenY;
        },
        { passive: true }
      );
      swipeTarget.addEventListener(
        'touchend',
        (e) => {
          if (touchStartX === null || touchStartY === null) return;
          if (!window.matchMedia('(max-width: 639px)').matches) {
            touchStartX = null;
            touchStartY = null;
            return;
          }
          const t = e.changedTouches[0];
          const dx = t.screenX - touchStartX;
          const dy = t.screenY - touchStartY;
          touchStartX = null;
          touchStartY = null;
          if (Math.abs(dx) < SWIPE_THRESHOLD_PX) return;
          // Ignore mostly-vertical gestures (page scroll)
          if (Math.abs(dy) > Math.abs(dx) * 0.85) return;
          if (dx < 0) {
            go(index + 1);
          } else {
            go(index - 1);
          }
          restart();
        },
        { passive: true }
      );
      swipeTarget.addEventListener('touchcancel', () => {
        touchStartX = null;
        touchStartY = null;
      });

      restart();
    });

    window.addEventListener('resize', scheduleHeroResize, { passive: true });

    // Countdowns (hero + anywhere)
    const tickCountdowns = () => {
      const now = Date.now();
      document.querySelectorAll('[data-countdown][data-countdown-end]').forEach((el) => {
        const raw = el.getAttribute('data-countdown-end');
        if (!raw) return;
        const end = Date.parse(raw);
        const out = el.querySelector('[data-countdown-display]');
        if (!out || !Number.isFinite(end)) return;
        const diff = end - now;
        if (diff <= 0) {
          out.textContent = '已結束';
          return;
        }
        const s = Math.floor(diff / 1000);
        const d = Math.floor(s / 86400);
        const h = Math.floor((s % 86400) / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        out.textContent = `${d}天 ${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
      });
    };
    tickCountdowns();
    window.setInterval(tickCountdowns, 1000);

    // Product recommendations (Shopify recommendations endpoint via section render)
    document.querySelectorAll('[data-product-recommendations]').forEach((wrap) => {
      const productId = wrap.getAttribute('data-product-id');
      const limit = wrap.getAttribute('data-limit') || '8';
      const handle = wrap.getAttribute('data-section-handle') || 'product-recommendations';
      const base = wrap.getAttribute('data-recos-url') || '/recommendations/products';
      if (!productId || productId === '0') return;

      const url = `${base}?section_id=${encodeURIComponent(handle)}&product_id=${encodeURIComponent(
        productId
      )}&limit=${encodeURIComponent(limit)}`;

      fetch(url, { headers: { Accept: 'text/html' } })
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          if (!html) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector('[data-product-recommendations-content]');
          const cur = wrap.querySelector('[data-product-recommendations-content]');
          if (!next || !cur) return;
          cur.innerHTML = next.innerHTML;
        })
        .catch(() => {});
    });

    // Quick view dialog
    const qvDialog = document.querySelector('[data-quickview-dialog]');
    const qvImg = qvDialog?.querySelector('[data-quickview-img]');
    const qvTitle = qvDialog?.querySelector('[data-quickview-title]');
    const qvPrice = qvDialog?.querySelector('[data-quickview-price]');
    const qvCompare = qvDialog?.querySelector('[data-quickview-compare]');
    const qvLink = qvDialog?.querySelector('[data-quickview-link]');

    const openQuickView = (btn) => {
      if (!qvDialog || !qvImg || !qvTitle || !qvPrice || !qvLink) return;
      const title = btn.getAttribute('data-qv-title') || '';
      const price = btn.getAttribute('data-qv-price') || '';
      const compare = btn.getAttribute('data-qv-compare') || '';
      const image = btn.getAttribute('data-qv-image') || '';
      const url = btn.getAttribute('data-qv-url') || '#';

      qvTitle.textContent = title;
      qvPrice.textContent = price;
      if (qvCompare) {
        qvCompare.textContent = compare;
        qvCompare.style.display = compare ? '' : 'none';
      }
      qvImg.setAttribute('src', image);
      qvImg.setAttribute('alt', title);
      qvLink.setAttribute('href', url);
      if (typeof qvDialog.showModal === 'function') qvDialog.showModal();
      else qvDialog.setAttribute('open', '');
    };

    document.addEventListener('click', (e) => {
      const btn = e.target instanceof Element ? e.target.closest('[data-quick-view]') : null;
      if (!btn) return;
      e.preventDefault();
      openQuickView(btn);
    });

    qvDialog?.querySelector('[data-quickview-close]')?.addEventListener('click', () => {
      qvDialog.close();
    });
    qvDialog?.addEventListener('click', (e) => {
      if (e.target === qvDialog) qvDialog.close();
    });

    // Collection page: mobile sidebar drawer
    document.querySelectorAll('[data-collection-layout]').forEach((layout) => {
      const toggle = layout.querySelector('[data-collection-nav-toggle]');
      const backdrop = layout.querySelector('[data-collection-nav-backdrop]');
      const closeBtn = layout.querySelector('[data-collection-nav-close]');
      if (!toggle || !backdrop) return;

      const mq = window.matchMedia('(max-width: 900px)');

      const close = () => {
        layout.classList.remove('is-collection-nav-open');
        document.body.classList.remove('collection-nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        backdrop.setAttribute('hidden', '');
      };

      const open = () => {
        layout.classList.add('is-collection-nav-open');
        document.body.classList.add('collection-nav-open');
        toggle.setAttribute('aria-expanded', 'true');
        backdrop.removeAttribute('hidden');
      };

      const onToggleClick = () => {
        if (!mq.matches) return;
        if (layout.classList.contains('is-collection-nav-open')) close();
        else open();
      };

      toggle.addEventListener('click', onToggleClick);
      backdrop.addEventListener('click', () => {
        if (layout.classList.contains('is-collection-nav-open')) close();
      });
      closeBtn?.addEventListener('click', close);

      layout.querySelectorAll('.collection-sidebar a.collection-sidebar__link').forEach((a) => {
        a.addEventListener('click', () => {
          if (mq.matches) close();
        });
      });

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && layout.classList.contains('is-collection-nav-open')) close();
      });

      mq.addEventListener('change', () => {
        if (!mq.matches) close();
      });
    });

    // Customer addresses: delete (Shopify.postLink when available)
    document.querySelectorAll('[data-address-delete]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const msg = btn.getAttribute('data-msg') || '';
        const url = btn.getAttribute('data-url');
        if (!url || (msg && !window.confirm(msg))) return;
        const post =
          typeof window.Shopify !== 'undefined' && typeof window.Shopify.postLink === 'function';
        if (!post) {
          window.alert('無法送出刪除（缺少 Shopify storefront 介面）；請換另一瀏覽器或使用登入／地址預設程式。');
          return;
        }
        window.Shopify.postLink(url, { parameters: { _method: 'delete' } });
      });
    });

    // Quick add to cart (Cart API)
    document.addEventListener('click', async (e) => {
      const btn = e.target instanceof Element ? e.target.closest('[data-quick-add]') : null;
      if (!btn) return;
      e.preventDefault();
      const id = btn.getAttribute('data-variant-id');
      if (!id) return;
      const label = btn.textContent;
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        });
        if (!res.ok) throw new Error('add failed');
        btn.textContent = '已加入 ✓';
        window.setTimeout(() => {
          btn.textContent = label;
          btn.disabled = false;
        }, 1600);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch {
        btn.textContent = '失敗，重試';
        window.setTimeout(() => {
          btn.textContent = label;
          btn.disabled = false;
        }, 1800);
      }
    });

    // Singles collection: rarity tab filter (loads full collection when filtered)
    document.querySelectorAll('[data-singles-collection]').forEach((root) => {
      const tabs = Array.from(root.querySelectorAll('[data-singles-rarity-tab]'));
      const groupedView = root.querySelector('[data-singles-grouped-view]');
      const filteredView = root.querySelector('[data-singles-filtered-view]');
      const filteredGrid = root.querySelector('[data-singles-filtered-grid]');
      const filteredEmpty = root.querySelector('[data-singles-filtered-empty]');
      const pagination = root.querySelector('[data-singles-pagination]');
      const handle = root.getAttribute('data-collection-handle');
      const expectedCount = Number(root.getAttribute('data-collection-product-count') || 0);
      if (tabs.length === 0 || !handle) return;

      let productsCache = null;
      let productsPromise = null;

      const escapeHtml = (value) => String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

      const normalizeRarity = (value) => String(value || '').toLowerCase().trim();

      const getRarity = (product) => {
        const tags = String(product.tags || '')
          .split(',')
          .map((tag) => tag.trim().toLowerCase())
          .filter(Boolean);
        const tagRarity = tags.find((tag) => tag.startsWith('rarity-') || tag.startsWith('rarity:'));
        if (tagRarity) {
          return tagRarity.replace(/^rarity[-:]/, '').toUpperCase();
        }
        const handleMatch = String(product.handle || '').match(/^rm-([a-z]+)-/i);
        if (handleMatch) return handleMatch[1].toUpperCase();
        const titleMatch = String(product.title || '').match(/^RM-([A-Z]+)-/i);
        if (titleMatch) return titleMatch[1].toUpperCase();
        return '';
      };

      const getCardNumber = (product) => {
        const handleMatch = String(product.handle || '').match(/-(\d+)$/);
        if (handleMatch) return handleMatch[1];
        const titleMatch = String(product.title || '').match(/-(\d+)$/);
        return titleMatch ? titleMatch[1] : '';
      };

      const sortProducts = (products) => products.slice().sort((a, b) => {
        const rarityCompare = getRarity(a).localeCompare(getRarity(b));
        if (rarityCompare !== 0) return rarityCompare;
        return getCardNumber(a).localeCompare(getCardNumber(b), undefined, { numeric: true });
      });

      const fetchAllProducts = async (forceRefresh = false) => {
        if (!forceRefresh && productsCache) return productsCache;
        if (!forceRefresh && productsPromise) return productsPromise;

        if (forceRefresh) {
          productsCache = null;
          productsPromise = null;
        }

        productsPromise = (async () => {
          const products = [];
          let page = 1;
          while (page <= 20) {
            const res = await fetch(`/collections/${handle}/products.json?limit=50&page=${page}`);
            if (!res.ok) break;
            const data = await res.json();
            products.push(...(data.products || []));
            if (!data.products || data.products.length < 50) break;
            page += 1;
          }
          productsCache = sortProducts(products);
          return productsCache;
        })();

        return productsPromise;
      };

      const buildCardHtml = (product) => {
        const variant = (product.variants && product.variants[0]) || {};
        const rarity = getRarity(product);
        const cardNumber = getCardNumber(product);
        // Storefront /products.json returns decimal currency strings (e.g. "5.00"), not cents.
        const price = parseFloat(variant.price || product.price || 0).toFixed(2);
        const image = product.images && product.images[0];
        const imageHtml = image
          ? `<img src="${escapeHtml(image.src)}" alt="${escapeHtml(image.alt || product.title || '')}" loading="lazy" width="480" class="single-card-item__img">`
          : '<div class="single-card-item__placeholder tech-grid" aria-hidden="true"></div>';
        const soldOut = variant.available === false
          ? '<span class="single-card-item__soldout" aria-hidden="true">Sold Out</span>'
          : '';
        const stockQty = Number(variant.inventory_quantity || 0);
        const stockHtml = variant.inventory_management && stockQty > 0 && stockQty <= 5
          ? `<div class="single-card-item__stock">剩 ${stockQty} 張</div>`
          : '';

        return `
          <a href="/products/${escapeHtml(product.handle)}" class="single-card-item glass-card" data-single-card-item data-rarity="${escapeHtml(rarity)}">
            <div class="single-card-item__media">
              ${soldOut}
              ${imageHtml}
            </div>
            <div class="single-card-item__body">
              ${rarity ? `<span class="single-card-item__rarity">${escapeHtml(rarity)}</span>` : ''}
              <h3 class="single-card-item__title">${escapeHtml(product.title || '')}</h3>
              ${cardNumber ? `<div class="single-card-item__number">#${escapeHtml(cardNumber)}</div>` : ''}
              <div class="single-card-item__price gradient-text">HK$ ${price}</div>
              ${stockHtml}
            </div>
          </a>
        `;
      };

      const setActiveTab = (rarity) => {
        tabs.forEach((tab) => {
          const tabRarity = tab.getAttribute('data-rarity') || 'all';
          const active = tabRarity === 'all'
            ? rarity === 'all'
            : normalizeRarity(tabRarity) === normalizeRarity(rarity);
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      const updateUrl = (rarity) => {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        if (rarity === 'all') {
          url.searchParams.delete('rarity');
        } else {
          url.searchParams.set('rarity', rarity);
        }
        window.history.replaceState({}, '', url);
      };

      const showGroupedView = () => {
        if (groupedView) groupedView.hidden = false;
        if (filteredView) filteredView.hidden = true;
        if (pagination) pagination.hidden = false;
        if (filteredGrid) filteredGrid.innerHTML = '';
        if (filteredEmpty) filteredEmpty.hidden = true;
      };

      const applyRarity = async (rarity) => {
        setActiveTab(rarity);
        updateUrl(rarity);

        if (rarity === 'all') {
          showGroupedView();
          return;
        }

        if (groupedView) groupedView.hidden = true;
        if (filteredView) filteredView.hidden = false;
        if (pagination) pagination.hidden = true;
        if (filteredGrid) {
          filteredGrid.innerHTML = '<p class="section__sub">載入中…</p>';
        }
        if (filteredEmpty) filteredEmpty.hidden = true;

        try {
          let products = await fetchAllProducts(true);
          if (expectedCount > 0 && products.length < expectedCount) {
            products = await fetchAllProducts(true);
          }

          const filtered = products.filter(
            (product) => normalizeRarity(getRarity(product)) === normalizeRarity(rarity)
          );

          if (!filteredGrid) return;

          if (filtered.length === 0) {
            filteredGrid.innerHTML = '';
            if (filteredEmpty) filteredEmpty.hidden = false;
            return;
          }

          filteredGrid.innerHTML = filtered.map(buildCardHtml).join('');
          filteredView?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch {
          if (filteredGrid) {
            filteredGrid.innerHTML = '<p class="section__sub">無法載入商品，請重新整理頁面。</p>';
          }
        }
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          applyRarity(tab.getAttribute('data-rarity') || 'all');
        });
      });

      const initialRarity = new URL(window.location.search).get('rarity');
      if (
        initialRarity
        && tabs.some((tab) => normalizeRarity(tab.getAttribute('data-rarity')) === normalizeRarity(initialRarity))
      ) {
        const matchedTab = tabs.find(
          (tab) => normalizeRarity(tab.getAttribute('data-rarity')) === normalizeRarity(initialRarity)
        );
        applyRarity(matchedTab ? matchedTab.getAttribute('data-rarity') : initialRarity);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

